import React from 'react';
import { Link } from 'react-router-dom';
import { claimTopics } from './data';

const ClaimsList = () => {
    // Show only claims marked as published in data.js
    const publishedClaims = claimTopics
        .filter(topic => topic.published === true)
        .sort((a, b) => {
            const titleA = a.title.replace(/^['"]|['"]$/g, '');
            const titleB = b.title.replace(/^['"]|['"]$/g, '');
            return titleA.localeCompare(titleB);
        });

    // Use customUrl if set, otherwise fall back to slug
    const getClaimUrl = (topic) => {
        return topic.customUrl || topic.slug;
    };

    return (
        <>
            <h2 className="subheading mb-1 mobile:mb-4">Claims</h2>

            {publishedClaims.map((topic, index) => (
                <Link
                    key={topic.id}
                    to={`/${getClaimUrl(topic)}`}
                >
                    <div className="claim-link">
                        {topic.title}
                    </div>
                </Link>
            ))}

            <div className="claim-coming-soon">+ more coming soon</div>
        </>
    )
}

export default ClaimsList;
